import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './styles/website-theme.css';

// Debug: Expose React and ReactDOM globally
if (typeof window !== 'undefined') {
  (window as any).React = React;
  (window as any).ReactDOM = ReactDOM;
  console.log('[MAIN] React and ReactDOM exposed globally for debugging');
}

// Remove loading screen once React app is ready
const removeLoadingScreen = () => {
  const loadingScreen = document.querySelector('.loading-screen');
  if (loadingScreen) {
    loadingScreen.remove();
  }
};

// Global error handler for uncaught errors
window.addEventListener('error', (event) => {
  console.error('Global error:', event.error);
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
});

// Performance monitoring
if (import.meta.env.DEV) {
  // Only in development
  const startTime = performance.now();
  
  window.addEventListener('load', () => {
    const loadTime = performance.now() - startTime;
    console.log(`App loaded in ${loadTime.toFixed(2)}ms`);
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <App />
);

// Remove loading screen after a short delay to ensure smooth transition
setTimeout(removeLoadingScreen, 100);